import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GridService } from "../shared/grid/grid.service";
import { DeviceVersion } from "../models/deviceVersion.model";
import { of } from "rxjs";
import { catchError } from "rxjs/operators";
import { ToastService } from "./toast.service";

@Injectable({
    providedIn: "root",
})
export class DeviceVersionService extends GridService<DeviceVersion> {
    constructor(
        http: HttpClient,
        private toastService: ToastService,
    ) {
        super("DeviceVersion", http);
    }

    getDeviceVersionLookupList() {
        return this.http
            .get<
                DeviceVersion[]
            >(this.getApiUrl("DeviceVersion/GetDeviceVersionLookupList"))
            .pipe(
                catchError((error) => {
                    this.toastService.displayErrorMessage(
                        "Error loading device versions",
                        true,
                    );
                    return of([]);
                }),
            );
    }
}
